import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { MultiSelectBuildProps } from 'components/molecules/MultiSelectBuild'
import { optionsDefault } from 'components/molecules/SelectBuild/constants'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { FormReportKeys } from 'pages/Report/types'

interface Schema {
    id: FormReportKeys
}

interface FormReportInterface {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    multiSelect?: MultiSelectBuildProps & Schema
    layout: LayoutProps
}

export const FormReportValue = (UFDetran?: string): FormReportInterface[] => {
    const checkUfToDetran = () => {
        return optionsDefault.ufContract.some((data) => data.value === UFDetran)
            ? UFDetran
            : ''
    }

    return [
        {
            input: {
                id: 'dataInicio',
                label: 'Data Inicial (Data Registro)',
                placeholder: 'dd/mm/aaaa',
                type: 'date'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'dataFinal',
                label: 'Data Final',
                placeholder: 'dd/mm/aaaa',
                type: 'date'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            multiSelect: {
                id: 'operacao',
                label: 'Serviço',
                optionsType: 'operationWithoutALL'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        },
        {
            select: {
                id: 'status',
                label: 'Status',
                optionsType: 'statusOperacao',
                defaultValue: 'TODOS'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            multiSelect: {
                id: 'detran',
                label: 'Detrans',
                optionsType: 'ufContract',
                defaultValue: checkUfToDetran(),
                isDisable: checkUfToDetran() === UFDetran
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            multiSelect: {
                id: 'ufsTaxaRegistroZerada',
                label: 'Detrans com taxa zerada',
                optionsType: 'ufContract'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'chassi',
                label: 'Chassi',
                maxLength: 24
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        }
    ]
}
